import { render } from "./Results.vue?vue&type=template&id=3f53b26e"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=3f53b26e&lang=css"
script.render = render

export default script